import { Quote, Star } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/site/Reveal";
import { TESTIMONIAL_META } from "@/data/content";
import { useLanguage } from "@/i18n/LanguageContext";

export const Testimonials = () => {
    const { t } = useLanguage();

    return (
        <section id="testimonials" className="relative py-24 md:py-32 bg-surface/40" data-testid="testimonials-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <SectionHeader
                    number={t.testimonials.number}
                    label={t.testimonials.label}
                    title={t.testimonials.title}
                />
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {t.testimonials.items.map((item, i) => {
                        const meta = TESTIMONIAL_META[i];
                        return (
                            <Reveal key={meta.name} delay={i * 0.12}>
                                <figure
                                    className="group glass-card glass-card-hover rounded-2xl p-8 h-full flex flex-col transition-transform duration-500 hover:-translate-y-2 hover:shadow-[0_8px_32px_rgba(0,0,0,0.4),0_0_24px_rgba(0,210,255,0.12)]"
                                    data-testid={`testimonial-card-${i}`}
                                >
                                    <Quote className="h-8 w-8 text-cyan-400/40 mb-5 transition-colors duration-300 group-hover:text-cyan-400" strokeWidth={1.5} />
                                    <blockquote className="text-sm md:text-base text-zinc-300 leading-relaxed font-light flex-1">
                                        &ldquo;{item.quote}&rdquo;
                                    </blockquote>
                                    <div className="mt-6 flex gap-1" aria-label={t.testimonials.ratingLabel}>
                                        {Array.from({ length: 5 }).map((_, s) => (
                                            <Star key={s} className="h-4 w-4 fill-cyan-400 text-cyan-400" />
                                        ))}
                                    </div>
                                    <figcaption className="mt-5 flex items-center gap-4 border-t border-white/5 pt-5">
                                        <img
                                            src={meta.avatar}
                                            alt={`Portrait of ${meta.name}`}
                                            loading="lazy"
                                            className="h-11 w-11 rounded-full object-cover ring-2 ring-cyan-400/20"
                                        />
                                        <div>
                                            <p className="font-display font-bold text-white text-sm">{meta.name}</p>
                                            <p className="font-mono text-xs text-zinc-500">{item.role}</p>
                                        </div>
                                    </figcaption>
                                </figure>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
